/* eslint-disable */
import * as Types from '../../graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AttachmentFragment = { __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string };

export type AttachmentWithClientVisibilityFragment = { __typename: 'AttachmentWithClientVisibility', id: string, title: string, mimeType: string, url: string, group: string, clientVisibility: boolean };

export type AttachmentSnapshotFragment = { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string };

export type Attachments_Building_Fragment = { __typename: 'Building', id: string, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type Attachments_Project_Fragment = { __typename: 'Project', id: string, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type Attachments_Quote_Fragment = { __typename: 'Quote', id: string, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type Attachments_QuoteTemplate_Fragment = { __typename: 'QuoteTemplate', id: string, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type Attachments_Request_Fragment = { __typename: 'Request', id: string, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type Attachments_Requirement_Fragment = { __typename: 'Requirement', id: string, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type Attachments_ShoppableTemplate_Fragment = { __typename: 'ShoppableTemplate', id: string, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type Attachments_TaskDocument_Fragment = { __typename: 'TaskDocument', id: string, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type AttachmentsFragment = Attachments_Building_Fragment | Attachments_Project_Fragment | Attachments_Quote_Fragment | Attachments_QuoteTemplate_Fragment | Attachments_Request_Fragment | Attachments_Requirement_Fragment | Attachments_ShoppableTemplate_Fragment | Attachments_TaskDocument_Fragment;

export type AttachmentsWithClientVisibilityFragment = { __typename: 'Item', id: string, attachments: Array<{ __typename: 'AttachmentWithClientVisibility', id: string, title: string, mimeType: string, url: string, group: string, clientVisibility: boolean }> };

export type AddAttachmentMutationVariables = Types.Exact<{
  owner: Types.Scalars['ID'];
  attachment: Types.AttachmentInput;
}>;


export type AddAttachmentMutation = { addAttachment: { __typename: 'AddAttachmentResult', attachment: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } };

export type AddAttachmentsMutationVariables = Types.Exact<{
  owner: Types.Scalars['ID'];
  attachments: Array<Types.AttachmentInput>;
}>;


export type AddAttachmentsMutation = { addAttachments: { __typename: 'AddAttachmentsResult', attachments: Array<{ __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }> } };

export type ModifyAttachmentMutationVariables = Types.Exact<{
  ownerId: Types.Scalars['ID'];
  attachmentId: Types.Scalars['ID'];
  url?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ModifyAttachmentMutation = { modifyAttachment: { __typename: 'ModifyAttachmentResult', attachment: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } };

export type RemoveAttachmentMutationVariables = Types.Exact<{
  ownerId: Types.Scalars['ID'];
  attachmentId: Types.Scalars['ID'];
}>;


export type RemoveAttachmentMutation = { removeAttachment: { __typename: 'RemoveAttachmentResult', ok: boolean } };

export const AttachmentSnapshotFragmentDoc = gql`
    fragment AttachmentSnapshot on AttachmentSnapshot {
  id
  title
  mimeType
  url
  group
}
    `;
export const AttachmentFragmentDoc = gql`
    fragment Attachment on Attachment {
  id
  title
  mimeType
  url
  group
}
    `;
export const AttachmentsFragmentDoc = gql`
    fragment Attachments on WithAttachments {
  id
  attachments {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc}`;
export const AttachmentWithClientVisibilityFragmentDoc = gql`
    fragment AttachmentWithClientVisibility on AttachmentWithClientVisibility {
  id
  title
  mimeType
  url
  group
  clientVisibility
}
    `;
export const AttachmentsWithClientVisibilityFragmentDoc = gql`
    fragment AttachmentsWithClientVisibility on WithAttachmentsWithClientVisibility {
  id
  attachments {
    ...AttachmentWithClientVisibility
  }
}
    ${AttachmentWithClientVisibilityFragmentDoc}`;
export const AddAttachmentDocument = gql`
    mutation AddAttachment($owner: ID!, $attachment: AttachmentInput!) {
  addAttachment(owner: $owner, attachment: $attachment) {
    attachment {
      ...AttachmentSnapshot
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export type AddAttachmentMutationFn = Apollo.MutationFunction<AddAttachmentMutation, AddAttachmentMutationVariables>;

/**
 * __useAddAttachmentMutation__
 *
 * To run a mutation, you first call `useAddAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttachmentMutation, { data, loading, error }] = useAddAttachmentMutation({
 *   variables: {
 *      owner: // value for 'owner'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useAddAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<AddAttachmentMutation, AddAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttachmentMutation, AddAttachmentMutationVariables>(AddAttachmentDocument, options);
      }
export type AddAttachmentMutationHookResult = ReturnType<typeof useAddAttachmentMutation>;
export type AddAttachmentMutationResult = Apollo.MutationResult<AddAttachmentMutation>;
export type AddAttachmentMutationOptions = Apollo.BaseMutationOptions<AddAttachmentMutation, AddAttachmentMutationVariables>;
export const AddAttachmentsDocument = gql`
    mutation AddAttachments($owner: ID!, $attachments: [AttachmentInput!]!) {
  addAttachments(owner: $owner, attachments: $attachments) {
    attachments {
      ...AttachmentSnapshot
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export type AddAttachmentsMutationFn = Apollo.MutationFunction<AddAttachmentsMutation, AddAttachmentsMutationVariables>;

/**
 * __useAddAttachmentsMutation__
 *
 * To run a mutation, you first call `useAddAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttachmentsMutation, { data, loading, error }] = useAddAttachmentsMutation({
 *   variables: {
 *      owner: // value for 'owner'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useAddAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<AddAttachmentsMutation, AddAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttachmentsMutation, AddAttachmentsMutationVariables>(AddAttachmentsDocument, options);
      }
export type AddAttachmentsMutationHookResult = ReturnType<typeof useAddAttachmentsMutation>;
export type AddAttachmentsMutationResult = Apollo.MutationResult<AddAttachmentsMutation>;
export type AddAttachmentsMutationOptions = Apollo.BaseMutationOptions<AddAttachmentsMutation, AddAttachmentsMutationVariables>;
export const ModifyAttachmentDocument = gql`
    mutation ModifyAttachment($ownerId: ID!, $attachmentId: ID!, $url: String) {
  modifyAttachment(owner: $ownerId, attachmentId: $attachmentId, url: $url) {
    attachment {
      ...AttachmentSnapshot
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export type ModifyAttachmentMutationFn = Apollo.MutationFunction<ModifyAttachmentMutation, ModifyAttachmentMutationVariables>;

/**
 * __useModifyAttachmentMutation__
 *
 * To run a mutation, you first call `useModifyAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyAttachmentMutation, { data, loading, error }] = useModifyAttachmentMutation({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      attachmentId: // value for 'attachmentId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useModifyAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ModifyAttachmentMutation, ModifyAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyAttachmentMutation, ModifyAttachmentMutationVariables>(ModifyAttachmentDocument, options);
      }
export type ModifyAttachmentMutationHookResult = ReturnType<typeof useModifyAttachmentMutation>;
export type ModifyAttachmentMutationResult = Apollo.MutationResult<ModifyAttachmentMutation>;
export type ModifyAttachmentMutationOptions = Apollo.BaseMutationOptions<ModifyAttachmentMutation, ModifyAttachmentMutationVariables>;
export const RemoveAttachmentDocument = gql`
    mutation RemoveAttachment($ownerId: ID!, $attachmentId: ID!) {
  removeAttachment(modelId: $ownerId, attachmentId: $attachmentId) {
    ok
  }
}
    `;
export type RemoveAttachmentMutationFn = Apollo.MutationFunction<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>;

/**
 * __useRemoveAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentMutation, { data, loading, error }] = useRemoveAttachmentMutation({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>(RemoveAttachmentDocument, options);
      }
export type RemoveAttachmentMutationHookResult = ReturnType<typeof useRemoveAttachmentMutation>;
export type RemoveAttachmentMutationResult = Apollo.MutationResult<RemoveAttachmentMutation>;
export type RemoveAttachmentMutationOptions = Apollo.BaseMutationOptions<RemoveAttachmentMutation, RemoveAttachmentMutationVariables>;